import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ScannerPrintDetailComponent } from './scanner-print-detail.component';

const routes: Routes = [
  {
    path: '',
    component: ScannerPrintDetailComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScannerPrintDetailRoutingModule {}
